<template>
    <rkm-overlay>
        <rkm-layout-body title="Fechamento de exames">
            <template v-slot:actions>
                <rkm-button
                    @click="$refs.Form.save()"
                    color="primary"
                >
                    Salvar
                </rkm-button>
            </template>

            <rkm-layout-content>
                <Form
                    ref="Form"
                    :id="id"
                    @save="handleSave"
                    @handleAtualizaLancamento="handleAtualizaLancamento"
                />
            </rkm-layout-content>

        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
// Components.
import Form from '@/components/exame-imagem/fechamento/Form'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { Form },
    created() {

        this.setShowExitFormConfirmation()
    },
    methods: {
        ...mapActions(['setShowExitFormConfirmation', 'unsetShowExitFormConfirmation']),
        handleExit() {

            this.showExitConfirmation(async () => {

                this.unsetShowExitFormConfirmation()
                this.redirectToList();
            })
        },
        handleSave(data) {

            this.unsetShowExitFormConfirmation()
            this.redirectToList(data)
        },
        handleExitLancamento() {

            this.unsetShowExitFormConfirmation()
            this.redirectToList()
        },
        handleAtualizaLancamento(value) {

            this.unsetShowExitFormConfirmation()

            this.idPaciente = value
            this.$router.push({ name: 'exame-imagem-lancamento-edit', params: { id: this.idPaciente } })
        },

        redirectToList() {

            this.$router.push({ name: 'exame-imagem-fechamento-create' })
        },
    },
    props: {
        id: { type: Number, default: null }
    },
}
</script>